<template>
  <b-modal
    :id="id"
    size="lg"
    title="Person erfassen"
    v-model="isPersonModalVisible"
  >
    <b-alert v-model="hasUnknownError" variant="danger">
      {{ unknownErrorMessage }}
    </b-alert>

    <validation-observer ref="observer" v-slot="{ passes }">
      <b-form @submit.prevent="passes(onSubmit)">
        <person-add :form="form" />
      </b-form>
    </validation-observer>

    <template v-slot:modal-footer="{ hide }">
      <div class="w-100 button-wrapper">
        <b-button type="submit" variant="primary" class="float-right" disabled v-if="isSubmitting">
          <b-spinner small></b-spinner>
          Speichern & übernehmen
        </b-button>
        <b-button @click="onSubmit" variant="primary" class="float-right" v-else>Speichern & übernehmen</b-button>

        <b-button class="float-right" @click="hide(reset())">
          Schliessen
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import { ValidationObserver } from 'vee-validate'
  import { errorHandler } from '@/helpers/formHelper.js'
  import PersonAdd from '@/components/person/PersonAdd.vue'

  const getInitialData = () => ({
    form: {
      anrede: 'Herr',
      vorname: '',
      name: '',
      firma: '',
      zusatz: '',
      uid: '',
      oeffentlicheHand: false,
      strasse: '',
      hausNr: '',
      postfach: '',
      plz: '',
      ort: '',
      telefon: '',
      email: '',
      land: 16
    }
  })

  export default {
    components: {
      ValidationObserver,
      PersonAdd
    },
    data: () => ({
      isSubmitting: false,
      hasUnknownError: false,
      unknownErrorMessage: '',
      hasError: false,
      errorMessage: '',
      ...getInitialData()
    }),
    methods: {
      onSubmit () {
        this.$refs.observer.validate().then(success => {
          if (!success) {
            return
          }

          this.isSubmitting = true
          this.hasUnknownError = false
          this.hasError = false

          this.$store.dispatch('person/SAVE_PERSON', {
            isContactPerson: this.isContactPerson,
            formData: this.form
          }).then(res => {
            const { errors } = res

            if (errors) {
              this.isSubmitting = false
              return errorHandler(this, errors)
            }

            this.$store.commit('application/SET_PERSON_MODAL_VISIBLE', {
              boolShow: false
            })

            this.isSubmitting = false
            this.reset()
          }).catch(err => {
            this.isSubmitting = false
            this.hasUnknownError = true
            this.unknownErrorMessage = this.$t('formError.unknownwError')
            console.error(err)
          })
        })
      },
      reset () {
        Object.assign(this.$data, getInitialData())
        requestAnimationFrame(() => {
          this.$refs.observer.reset()
        })
      }
    },
    props: {
      isContactPerson: {
        type: Boolean
      },
      id: {
        type: String,
        required: true
      }
    },
    computed: {
      isPersonModalVisible: {
        set (value) {
          this.$store.commit('application/SET_PERSON_MODAL_VISIBLE', {
            boolShow: value
          })
        },
        get () {
          return this.$store.state.application.isPersonModalVisible
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .button-wrapper{
    .btn{
      margin-left: 1rem;
    }
  }
  .optional{
    text-decoration: underline;
  }
</style>
